import { useSelector } from 'react-redux';
import { useCallback } from 'react';

const usePlan = () => {
    const _PLAN = useSelector(state => state?.common?.planAccess);

    return useCallback((keys, andOr = 'and', product = 'recruit') => {
        // We have to pass "or , "and" as a string in second parameter, Here we are using default value "and"
        if (Array.isArray(keys)) {
            return Boolean(andOr?.toLowerCase() === 'and' 
            ? keys.every(key => _PLAN?.[product]?.[key]?.value === true)  // AND operation
            : keys.some(key => _PLAN?.[product]?.[key]?.value === true));  // OR operation
        }
        return Boolean(_PLAN?.[product]?.[keys]?.value ?? null);
    }, [_PLAN]);
};

export default usePlan;
